import PositionObject, { PositionObjectOptions } from "./PositionObject";

export type GraphicsObjectOptions = PositionObjectOptions

export default class GraphicObject<T, C> extends PositionObject {
	graphics = undefined as (undefined | T)
	graphicsMounted = false

	createGraphics() {
		return undefined as (undefined | T)
	}

	disposeGraphics() {

	}

	removeCallback = undefined as any

	addGraphics(canvas: C) {
		this.graphics = this.createGraphics()
		this.graphicsMounted = true
	}

	removeGraphics() {
		if (this.removeCallback) {
			this.removeCallback()
			this.removeCallback = undefined
		}

		this.disposeGraphics()
		this.graphicsMounted = false
	}

	dispose() {
		super.dispose()

		if (this.graphicsMounted) {
			this.removeGraphics()
		}
	}
}